module.exports = __webpack_public_path__ + "static/media/CostOpportunity_Angel_Desktop.2daa276a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CostOpportunity_Angel_Desktop.png
// module id = 366
// module chunks = 0